import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'door-open',
  size: 24,
  node: [
    ['path', { d: 'M10 21H2', key: '1sthdo' }],
    ['path', { d: 'M10 3H7a2 2 0 00-2 2v16', key: '15gt7x' }],
    ['path', { d: 'M14 12h.01', key: '1jfl7z' }],
    [
      'path',
      {
        d: 'M19 21V5a2 2 0 00-1.675-1.974l-6.163-1.013A1 1 0 0010 3v18a1 1 0 001.124.992z',
        key: 'tyvg9a',
      },
    ],
    ['path', { d: 'M22 21h-3', key: '1ec3tr' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name DoorOpen
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMjFIMiIgLz4KICA8cGF0aCBkPSJNMTAgM0g3YTIgMiAwIDAwLTIgMnYxNiIgLz4KICA8cGF0aCBkPSJNMTQgMTJoLjAxIiAvPgogIDxwYXRoIGQ9Ik0xOSAyMVY1YTIgMiAwIDAwLTEuNjc1LTEuOTc0bC02LjE2My0xLjAxM0ExIDEgMCAwMDEwIDN2MThhMSAxIDAgMDAxLjEyNC45OTJ6IiAvPgogIDxwYXRoIGQ9Ik0yMiAyMWgtMyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/door-open
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DoorOpen = createLucideIcon(__iconData);

export default DoorOpen;
